import * as yup from 'yup';


import {emailFormConstants} from '../index';


export const EMAIL_MAX_LENGTH = 200;


// ------ validations

export const SCHEMA_EMAIL_CONFIRMATION = yup.string()
    .nullable()
    .email()
    .max(EMAIL_MAX_LENGTH)
    .when(
        'email',
        (email, schema) => schema.test(
            'mismatch',
            '${emailConfirmation} is not matching',
            emailConfirmation => emailConfirmation === email
        )
    )
    .required();

export const SCHEMA_EMAIL_CONFIRMATION_FORM = yup.object()
    .shape({
        email: emailFormConstants.SCHEMA_EMAIL,
        emailConfirmation: SCHEMA_EMAIL_CONFIRMATION
    });
